import { BaseModel } from '../base-model'
import { NoteData } from './note.data'

export class Note extends BaseModel {
  patientId: string
  title: string
  text: string
  clinicianId: string
  clinician?: {
    title?: string
    name?: string
    abbreviation?: string
  }
  appointment?: {
    eid: string
    startAt: string
  }
  appointmentId?: string
  autoGenerated?: boolean

  constructor(data: NoteData) {
    super(data, true)
  }
}
